import { SingleCurrentValueConfigBlockState } from './types';

const defaultState: SingleCurrentValueConfigBlockState = {
    settings: {
        fontSize: 100,
        align: 'center',
        items: [],
    },
    databilities: [],
};

export default defaultState;
